import { useTranslations } from '@vocab/react';
import { Text, Strong, Stack, IconWorkExperience } from 'braid-design-system';

import type { ProfileCardView } from '../../../types/profile.types';

import translations from './.vocab';

interface Props {
  workHistories: ProfileCardView['workHistories'];
  count?: number;
  hideDuration?: boolean;
  boldText?: boolean;
  showIcon?: boolean;
}

export const WorkHistory = ({
  workHistories,
  count = 2,
  hideDuration = false,
  boldText = true,
  showIcon = false,
}: Props) => {
  const entriesToRender = workHistories.filter((_, index) => index < count);

  const { t } = useTranslations(translations);

  return (
    <Stack space="xsmall">
      {entriesToRender.map(
        ({ duration, roleTitle, companyName, foundInCV }, index) => {
          const shouldShowDuration = Boolean(duration) && !hideDuration;
          return (
            <Text
              key={`${roleTitle}-${index}`}
              data={{ testid: 'work-history' }}
              icon={
                showIcon ? (
                  <IconWorkExperience
                    tone="secondary"
                    data={{ testid: 'work-icon' }}
                  />
                ) : undefined
              }
              maxLines={1}
              size="small"
            >
              <span
                style={{
                  whiteSpace: 'pre-wrap',
                  fontStyle: foundInCV ? 'italic' : undefined,
                }}
              >
                {foundInCV && <>{t('FOUND_IN_CV')} </>}
                {t('JOB_AT_COMPANY', {
                  JobTitle: (_) =>
                    boldText ? <Strong>{roleTitle}</Strong> : roleTitle,
                  CompanyName: (_) =>
                    boldText ? <Strong>{companyName}</Strong> : companyName,
                })}{' '}
                {shouldShowDuration ? duration : null}
              </span>
            </Text>
          );
        },
      )}
    </Stack>
  );
};
